module.exports = __webpack_public_path__ + "img/home-bg.7cbebd04.png";